import { createContext } from "react";

export const ArticulosDepositoContext = createContext()
export const ArticulosDepositoReportContext = createContext()